export default __webpack_public_path__ + "static/media/img23.3a07dc3a.jpg";